<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="400" overlay-color="rgb(0, 0, 0)" overlay-opacity=".75">
      <v-card>
        <v-card-title class="text-h5 dialogHeader white--text mb-3">
          {{ $t("FileInvalidDialogTitle") }}
        </v-card-title>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="$emit('clear', 'Back')">
            {{ $t("Back") }}
          </v-btn>
          <v-btn color="error" depressed @click="$emit('clear')">
            {{ $t("Continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["show", "message"],
  data: () => ({})
};
</script>

<style scoped>
.dialogHeader {
  word-break: normal;
  background-color: var(--v-error-base);
}
</style>
